import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import moment from 'moment';

// MUI imports
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  IconButton,
  Grid,
  Typography,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Box,
  Paper,Autocomplete,Tabs,
  Tab,
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import CloseIcon from '@mui/icons-material/Close';
import edit from "../../../assets/images/edit2.png";
import axiosInstance from '../../../helpers/axios';
import CoapplicantEditForm from './CoapplicantEditForm';
import { useCurrentUser } from '../../../hooks/useCurrentUser';
import { useSelector } from 'react-redux';

const doctorInstituteIds = ["1a62ed6b-a5f5-4ab3-acfa-6e353b070149"]
export default function EditForm({ curruser }) {
  const location = useLocation();
  const [formOpen, setFormOpen] = useState(false);
  const [errors, setErrors] = useState({})
  const [startingPhrase,setStarterPhrase]=useState("Type Institute Name")
  const [instituteList,setInstituteList]=useState([])
  const [coApplicantUserData,setCoApplicantUserData]=useState('')
  // Initial form data
  const [formData, setFormData] = useState({
    instituteName: '',
    courseName: '',
    courseFees: '',
    email: '',
    dateOfBirth: null,
    gender: '',
    firstName: '',
    lastName: '',
    mobile: '',
    salary: '',
    studentName: '',
    currentAddress: '',
    panId: '',
    currentPincode: '',
    currentState: '',
    currentCity: '',
    officeAddress: '',
    maritalStatus: '',
    officePincode: '',
    officeState: '',
    officeCity: '',
    aadhaarId: '',
    loanTenure: '',
    fatherName:''
  });
  // Track changed fields
  const [changedFields, setChangedFields] = useState({});
  const [cra, setCra] = useState([]);
  const [selectedCRA, setSelectedCRA] = useState('');
  const [id,setId]=useState(null)

  // Doctor details section state
  const doctorRequiredFields = ['registrationNumber', 'yearOfRegistration', 'registeredCouncil', 'qualification'];
  const initialDoctorFormData = {
    registrationNumber: '',
    yearOfRegistration: '',
    registeredCouncil: '',
    qualification: '',
    certificateType1: '',
  };
  const [doctorDetailsOpen, setDoctorDetailsOpen] = useState(false);
  const [doctorDetailsExisted, setDoctorDetailsExisted] = useState(false);
  const [doctorFormData, setDoctorFormData] = useState(initialDoctorFormData);
  const [doctorError, setDoctorError] = useState('');
  const [certificateUrl1, setCertificateUrl1] = useState('');
  const [doctorUploading, setDoctorUploading] = useState(false);

  const maritalOptions = [
    { label: "Married", value: "Married" },
    { label: "Single", value: "Single" },
    { label: "Divorced", value: "Divorced" },
    { label: "Widowed/Others", value: "Widowed/Others" }
  ];

  // Gender options
  const genderOptions = [
    { label: "Male", value: "Male" },
    { label: "Female", value: "Female" }
  ];
  const editableStatuses = ["In Review", "In Submission"];
 
  const { status: currentStatus } = useSelector(state => state.appContext);
  const aadhaarEditableStatuses = ["In Submission", "In Review", "In Process", "In Sanction"];

  const isAadhaarEditable = aadhaarEditableStatuses.includes(currentStatus);
  const isInSanction=currentStatus==="In Sanction"
  
  const fieldDisabled =isInSanction || !editableStatuses.includes(currentStatus);
  const user = null;
  const decode = useCurrentUser();
  const Id = curruser?.userId;
  const appId = curruser?.applicationId;
  const instName = curruser?.instituteName;
  const isPersonalLoan = instName === 'Personal Loan'
  const isDoctorInstitute = doctorInstituteIds.includes(curruser?.instituteId);
    const [tabValue, setTabValue] = useState(0);
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
       if (newValue === 1) {
        const urlProfile = `/summary/coapplicant?id=${curruser?.coapplicants?.[0]?.coapplicantId || ""}&applicationId=${appId}&status=${currentStatus}`;
    axiosInstance.get(`${urlProfile}`,{
      headers:{
      }
    }).then((res) => {
      const userData = res?.data?.data;
      setCoApplicantUserData(res?.data?.data)
    })}
     const userUrl = `/admin/users`;
    axiosInstance.get(userUrl, {
      headers: {
      },
    }).then((res) => {
      setCra(res?.data?.data);
    }).catch((err) => {
    });

  };


 const handleInputChange = (eOrValue, fieldIdOverride = null) => {
    let fieldId, value;

    if (eOrValue && eOrValue.target) {
      ({ id: fieldId, value } = eOrValue.target);
    } else {
      value = eOrValue;
      fieldId = fieldIdOverride;
    }

    setFormData((prev) => ({ ...prev, [fieldId]: value }));
    setChangedFields((prev) => ({ ...prev, [fieldId]: value }));
  };


  const handleDateChange = (date) => {
    if (date) {
      // Format for display
      const displayDate = date.format('DD/MM/YYYY');
      // Format for API
      const apiDate = date.format('YYYY-MM-DD');
      
      setFormData(prevData => ({
        ...prevData,
        dateOfBirth: displayDate
      }));
      
      setChangedFields(prevChangedFields => ({
        ...prevChangedFields,
        dateOfBirth: apiDate
      }));
    } else {
      setFormData(prevData => ({
        ...prevData,
        dateOfBirth: null
      }));
      
      setChangedFields(prevChangedFields => ({
        ...prevChangedFields,
        dateOfBirth: ''
      }));
    }
  };

  const handleDoctorInputChange = (eOrValue, fieldIdOverride = null) => {
    let fieldId, value;

    if (eOrValue && eOrValue.target) {
      ({ id: fieldId, value } = eOrValue.target);
    } else {
      value = eOrValue;
      fieldId = fieldIdOverride;
    }

    setDoctorFormData((prev) => ({ ...prev, [fieldId]: value }));
    if (doctorError) {
      setDoctorError('');
    }
  };

  const handleAddDoctorDetails = () => {
    setDoctorDetailsOpen(true);
  };

  const handleRemoveDoctorDetails = () => {
    setDoctorFormData(initialDoctorFormData);
    setCertificateUrl1('');
    setDoctorDetailsOpen(false);
    setDoctorError('');
  };

  const handleDoctorFileChange = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = null;
    if (!file) return;

    if (!doctorFormData.certificateType1) {
      setDoctorError('Please select a file type before uploading.');
      return;
    }

    const uploadData = new FormData();
    uploadData.append('file', file);
    uploadData.append('type', doctorFormData.certificateType1);

    setDoctorUploading(true);
    setDoctorError('');
    try {
      const res = await axiosInstance.post('/file/upload', uploadData);
      const s3Url = res?.data?.data?.s3Url || '';
      setCertificateUrl1(s3Url);
    } catch (err) {
      setDoctorError('File upload failed. Please try again.');
    } finally {
      setDoctorUploading(false);
    }
  };

  const handleViewCertificate = async () => {
    if (!certificateUrl1) return;
    try {
      const res = await axiosInstance.get(`/file/url-content?path=${certificateUrl1}`);
      const presignedUrl = res?.data?.data;
      if (presignedUrl) {
        window.open(presignedUrl, '_blank');
      }
    } catch (err) {
      setDoctorError('Unable to open the uploaded file. Please try again.');
    }
  };


  const popUpForm = () => {
    setFormOpen(true);
    setChangedFields({}); // Reset changed fields
    
    const urlProfile = `/summary/user?id=${Id}&applicationId=${appId}&status=${currentStatus}`;
    axiosInstance.get(urlProfile,{
      headers:{
      }
    }).then((res) => {
      const userData = res.data.data;
      
      // Format the date of birth for display
      const formatteddateOfBirth = userData.dateOfBirth ? 
        userData.dateOfBirth.includes('-') ? 
          moment(userData.dateOfBirth).format('DD/MM/YYYY') : 
          userData.dateOfBirth 
        : null;
      
      setFormData({
        instituteName: userData.instituteName || '',
        courseName: userData.courseName || '',
        courseFees: userData.courseFees || '',
        email: userData.email || '',
        dateOfBirth: formatteddateOfBirth, // Use formatted date
        gender: userData.gender || '',
        firstName: userData.firstName || '',
        lastName: userData.lastName || '',
        mobile: userData.mobile || '',
        currentAddress: userData.currentAddress || '',
        officeAddress: userData.officeAddress || '',
        maritalStatus: userData.maritalStatus || '',
        studentName: userData.studentName || '',
        salary: userData.salary || '',
        panId: userData.panId || '',
        aadhaarId: userData.aadhaarId || '',
        currentPincode: userData.currentPincode || '',
        currentCity: userData.currentCity || '',
        currentState: userData.currentState || '',
        officePincode: userData.officePincode || '',
        officeCity: userData.officeCity || '',
        officeState: userData.officeState || '',
        loanTenure: userData.loanTenure || ''
      });

      // Pre-populate doctor details if they already exist on the record
      const hasDoctorDetails = doctorRequiredFields.some((field) => !!userData[field]);
      setDoctorDetailsExisted(hasDoctorDetails);
      setDoctorDetailsOpen(hasDoctorDetails);
      setDoctorFormData({
        registrationNumber: userData.registrationNumber || '',
        yearOfRegistration: userData.yearOfRegistration || '',
        registeredCouncil: userData.registeredCouncil || '',
        qualification: userData.qualification || '',
        certificateType1: userData.certificateType || '',
      });
      setCertificateUrl1(userData.certificateUrl || '');
      setDoctorError('');
    });

    const userUrl = `/admin/users`;
    axiosInstance.get(userUrl, {
      headers: {
      },
    }).then((res) => {
      setCra(res?.data?.data);
    }).catch((err) => {
    });
  };

  const handleSave = async () => {
    // Validate doctor details section together with the rest of the form
    if (doctorDetailsOpen) {
      const hasMissingDoctorField = doctorRequiredFields.some((field) => !doctorFormData[field]);
      if (hasMissingDoctorField) {
        setDoctorError('Please fill all doctor details fields before saving.');
        return;
      }
    }
    setDoctorError('');

    // Only include fields that have been changed
    if (Object.keys(changedFields).length === 0 && !selectedCRA && !doctorDetailsOpen && !doctorDetailsExisted) {
      alert("No changes made to save");
      return;
    }

    // Create payload with only required fields
    const payload = {
      applicationId: appId,
      userId: Id,
      instituteName: instName
    };

    // Add changed fields to payload
    for (const [key, value] of Object.entries(changedFields)) {
      payload[key] = value;
    }

    // Ensure maritalStatus is included if it was changed
    if (changedFields.maritalStatus) {
      payload.maritalStatus = changedFields.maritalStatus;
    }

    // Ensure gender is included if it was changed
    if (changedFields.gender) {
      payload.gender = changedFields.gender;
    }

    // Merge doctor details into the same update payload
    if (doctorDetailsOpen) {
      doctorRequiredFields.forEach((field) => {
        payload[field] = doctorFormData[field];
      });
      payload.certificateType1 = doctorFormData.certificateType1;
      payload.certificateUrl1 = certificateUrl1;
    } else if (doctorDetailsExisted) {
      // Doctor details were removed by the user - clear them on save
      doctorRequiredFields.forEach((field) => {
        payload[field] = '';
      });
      payload.certificateType1 = '';
      payload.certificateUrl1 = '';
    }

    try {
      const response = await axiosInstance.post('/summary/update', payload, {
        headers: {
        }
      });
      
      alert(`Details Updated ${response.data.message}`);
      
      // Handle CRA update if selected
      if (selectedCRA) {
        const updateCra = `/admin/application/update`;
        const craData = {
          applicationId: appId,
          cra: selectedCRA,
        };

        await axiosInstance.post(updateCra, craData, {
          headers: {
          },
        });
      }
      
      setTimeout(() => {
        window.location.reload(true);
      }, 1000);
    } catch (error) {
      console.error("Error updating data:", error);
      alert("Failed to update details. Please try again.");
    }
  };

  const getInstituteInfo = async (text) => {
    const trimmedText = text.trim();

    if (!trimmedText || trimmedText.length < 4) {
      setInstituteList([]);
      setStarterPhrase('Type Institute Name');
      return;
    }

    const instituteInfoUrl = `/institute/info/name?name=${trimmedText}`;
    try {
      const response = await axiosInstance.get(instituteInfoUrl, {
        headers: {
        },
      });

      const institutes = response?.data?.data || [];
      if (institutes.length === 0) {
        setInstituteList([]);
        setStarterPhrase('No institute found');
      } else {
        const formattedData = institutes.map((item) => ({
          label: item.brandName,
          id: item.id,
          ...item,
        }));
        setInstituteList(formattedData);
        setStarterPhrase('');
      }
    } catch (error) {
      console.error('Error fetching institute info:', error);
    }
  }

  return (
    <div>
      <img style={{height:'1vw',width:'1vw',cursor:'pointer'}} src={edit} onClick={popUpForm}/>      
      <Dialog 
        open={formOpen} 
        onClose={() => {
          setFormOpen(false);
          setSelectedCRA('');
        }}
        maxWidth="md"
        fullWidth
      >
  <DialogTitle sx={{ bgcolor: '#f5f5f5', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1 }}>
        
       <Typography variant="subtitle1" fontWeight="medium">
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          textColor="primary"
          indicatorColor="primary"
        >
          <Tab label="Application Form" />
       {currentStatus === "In Process" && curruser?.coapplicants?.[0]?.coapplicantId.length>0 && decode?.clientId !== '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361' && (   <Tab label="CoApplication Form" />)}
        </Tabs>
         </Typography> 
         <IconButton 
            onClick={() => {
              setFormOpen(false);
              setSelectedCRA('');
            }}
            size="small"
          >
            <CloseIcon fontSize="small" />
          </IconButton>
          
        </DialogTitle>
      <DialogContent sx={{ mt: 2 }}>
        {tabValue === 0 && <>
        
        <DialogContent dividers
              sx={{
                pointerEvents:
                  currentStatus === "In Sanction"
                    ? "none"
                    : "auto",
                "& .MuiOutlinedInput-root": {
                  backgroundColor: currentStatus === "In Sanction" ? "#f3f3f3 !important" : "inherit",
                },

                "& .MuiInputBase-input, & .MuiInputLabel-root, & .MuiTypography-root": {
                  color: currentStatus === "In Sanction" ? "#9e9e9e !important" : "inherit",
                  WebkitTextFillColor: currentStatus === "In Sanction" ? "#9e9e9e !important" : "inherit",
                },

                "& #aadhaarId": {
                  color: "#000 !important",
                  WebkitTextFillColor: "#000 !important",
                },

                "& label[for='aadhaarId']": {
                  color: "#000 !important",
                  WebkitTextFillColor: "#000 !important",
                },

                "& .MuiOutlinedInput-root:has(#aadhaarId)": {
                  backgroundColor: "#fff !important",
                }
              }}
              >
          <Box sx={{ mb: 2 }}>
            <FormControl sx={{ width: '220px', mb: 2 }}>
              <Select
                id="cra-select"
                value={selectedCRA}
                onChange={(e) => setSelectedCRA(e.target.value)}
                size="small"
                displayEmpty
                sx={{
                  "& .MuiSelect-select": {
                    textAlign: "center"
                  }
                }}
                renderValue={(selected) => {
                  return selected || "Re-assign CRA";
                }}
              >
                <MenuItem value="">Select CRA</MenuItem>
                {cra?.map((item, index) => (
                  <MenuItem key={index} value={item.name}>{item.name}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
          
          <Grid container spacing={2}>
          {decode?.clientId === '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361' ? (
            <Grid item xs={4}>
              <TextField
                id="instituteName"
                label={decode?.clientId === '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361' ? 'Loan Type' : 'Institute Name'}
                variant="outlined"
                fullWidth
                value={formData.instituteName}
                disabled
                size="small"
              />
            </Grid>):(
               <Grid item xs={4}>
       
      <Autocomplete
        id="instituteName"
        disabled={["institute_user", "institute_admin"].includes(decode?.role)}
        value={
          instituteList.find(
            (option) => option.label === formData?.instituteName
          ) || { label: formData?.instituteName || "" }
        }
        options={instituteList}
        getOptionLabel={(option) => option.label || ""}
        noOptionsText={startingPhrase}
       onChange={(event, newValue) => {
        setFormData((prev) => ({
          ...prev,
          instituteName: newValue?.label || "",
        }));
         setChangedFields((prev) => ({
      ...prev,
      instituteName: newValue?.label || "",
    }));

      }}
       onInputChange={(event, newInputValue, reason) => {
            if (reason === "input") { // only when user is typing
              setFormData((prev) => ({
                ...prev,
                instituteName: newInputValue,
              }));
              getInstituteInfo(newInputValue);
            }
          }}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Institute Name"
            error={!!errors.instituteName}
            helperText={errors.instituteName}
         sx={{
              width: "100%",
              maxWidth: 350,
              "& .MuiInputBase-root": {
                height: 40,
                fontFamily: "Inter-Medium",
                fontSize: "14px",
              },
            }}
          />
        )}
      />

                </Grid>
            )}
            
            {decode?.clientId !== '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361' && (
              <Grid item xs={4}>
                <TextField
                  id="courseName"
                  label="Course"
                  variant="outlined"
                  fullWidth
                  value={formData.courseName}
                  disabled={!editableStatuses.includes(currentStatus)}
                  onChange={handleInputChange}
                  size="small"
                />
            </Grid>
            )}
            <Grid item xs={4}>
              <TextField
                id="courseFees"
                label={decode?.clientId === '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361' ? 'Loan Amount' : 'Course Fees'}
                variant="outlined"
                fullWidth
                value={formData.courseFees}
                disabled={!(isPersonalLoan || editableStatuses.includes(currentStatus))}
                onChange={handleInputChange}
                size="small"
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                id="loanTenure"
                label="Tenure"
                variant="outlined"
                fullWidth
                type="number"
                value={formData.loanTenure}
                onChange={handleInputChange}
                disabled={!(isPersonalLoan || editableStatuses.includes(currentStatus))}
                size="small"
              />
            </Grid>
             <Grid item xs={4}>
              <TextField
                id="panId"
                label="Pan Number"
                variant="outlined"
                fullWidth
                type="string"
                value={formData.panId}
                onChange={handleInputChange}
                disabled={!(isPersonalLoan || editableStatuses.includes(currentStatus))}
                size="small"
              />
            </Grid>
          </Grid>

          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={4}>
              <TextField
                id="firstName"
                label="First Name"
                variant="outlined"
                fullWidth
                value={formData.firstName}
                onChange={handleInputChange}
                size="small"
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                id="lastName"
                label="Last Name"
                variant="outlined"
                fullWidth
                value={formData.lastName}
                onChange={handleInputChange}
                size="small"
              />
            </Grid>
            <Grid item xs={4}>
              <FormControl fullWidth size="small">
                <InputLabel id="gender-label">Gender</InputLabel>
                <Select
                  labelId="gender-label"
                  id="gender"
                  value={formData.gender}
                  label="Gender"
                  disabled={!editableStatuses.includes(currentStatus)}
                  onChange={(e) => {
                    setFormData((prev) => ({ ...prev, gender: e.target.value }));
                    setChangedFields((prev) => ({ ...prev, gender: e.target.value }));
                  }}
                >
                  <MenuItem value="">
                    <em>Select Gender</em>
                  </MenuItem>
                  {genderOptions?.map((item, index) => (
                    <MenuItem key={index} value={item.value}>
                      {item.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={4}>
              <TextField
                id="email"
                label="Email"
                variant="outlined"
                fullWidth
                value={formData.email}
                onChange={handleInputChange}
                disabled={!editableStatuses.includes(currentStatus)}
                size="small"
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                id="mobile"
                label="Phone Number"
                variant="outlined"
                fullWidth
                value={formData.mobile}
                onChange={handleInputChange}
                disabled={(currentStatus === "In Review" || currentStatus === "In Process") && curruser?.instituteId !== "9d5eca4b-54f7-42a7-8794-1413e00b462e"}
                size="small"
              />
            </Grid>
            <Grid item xs={4}>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DatePicker
                  label="Date of Birth"
                  value={formData.dateOfBirth ? moment(formData.dateOfBirth, 'DD/MM/YYYY') : null}
                  onChange={handleDateChange}
                  disabled={!editableStatuses.includes(currentStatus)}
                  format="DD/MM/YYYY"
                  slotProps={{
                    textField: {
                      size: "small",
                      fullWidth: true,
                      id: "dateOfBirth"
                    },
                    actionBar: {
                      actions: ['cancel', 'accept']
                    }
                  }}
                  // This ensures the picker closes on date selection
                  closeOnSelect={true}
                />
              </LocalizationProvider>
            </Grid>
          </Grid>

          <Box sx={{ mt: 3, mb: 2 }}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Paper elevation={0} sx={{ bgcolor: '#f5f5f5', p: 2, borderRadius: 2 }}>
                  <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
                    APPLICANT ADDRESS
                  </Typography>
                  <Box sx={{ mt: 1 }}>
                    <TextField
                      id="currentAddress"
                      label="Address"
                      variant="outlined"
                      fullWidth
                      value={formData.currentAddress}
                      onChange={handleInputChange}
                      size="small"
                      sx={{ mb: 2 }}
                    />
                    <TextField
                      id="currentCity"
                      label="City"
                      variant="outlined"
                      fullWidth
                      value={formData.currentCity}
                      onChange={handleInputChange}
                      size="small"
                      sx={{ mb: 2 }}
                    />
                    <TextField
                      id="currentState"
                      label="State"
                      variant="outlined"
                      fullWidth
                      value={formData.currentState}
                      onChange={handleInputChange}
                      size="small"
                      sx={{ mb: 2 }}
                    />
                    <TextField
                      id="currentPincode"
                      label="Pin Code"
                      variant="outlined"
                      fullWidth
                      value={formData.currentPincode}
                      onChange={handleInputChange}
                      size="small"
                    />
                  </Box>
                </Paper>
              </Grid>
              <Grid item xs={6}>
                <Paper elevation={0} sx={{ bgcolor: '#f5f5f5', p: 2, borderRadius: 2 }}>
                  <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
                    OFFICE ADDRESS
                  </Typography>
                  <Box sx={{ mt: 1 }}>
                    <TextField
                      id="officeAddress"
                      label="Office Address"
                      variant="outlined"
                      fullWidth
                      value={formData.officeAddress}
                      onChange={handleInputChange}
                      size="small"
                      sx={{ mb: 2 }}
                    />
                    <TextField
                      id="officeCity"
                      label="Office City"
                      variant="outlined"
                      fullWidth
                      value={formData.officeCity}
                      onChange={handleInputChange}
                      size="small"
                      sx={{ mb: 2 }}
                    />
                    <TextField
                      id="officeState"
                      label="Office State"
                      variant="outlined"
                      fullWidth
                      value={formData.officeState}
                      onChange={handleInputChange}
                      size="small"
                      sx={{ mb: 2 }}
                    />
                    <TextField
                      id="officePincode"
                      label="Office Pin Code"
                      variant="outlined"
                      fullWidth
                      value={formData.officePincode}
                      onChange={handleInputChange}
                      size="small"
                    />
                  </Box>
                </Paper>
              </Grid>
            </Grid>
          </Box>

          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={4}>
              <FormControl fullWidth size="small">
                <InputLabel id="marital-status-label">Marital Status</InputLabel>
                <Select
                labelId="marital-status-label"
                id="maritalStatus"
                value={formData.maritalStatus}
                label="Marital Status"
                onChange={(e) => handleInputChange(e, "maritalStatus")}
              >
                <MenuItem value="">
                  <em>Select Marital Status</em>
                </MenuItem>
                {maritalOptions?.map((item, index) => (
                  <MenuItem key={index} value={item.value}>
                    {item.label}
                  </MenuItem>
                ))}
              </Select>

              </FormControl>
            </Grid>
            {decode?.clientId !== '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361' && (
              <Grid item xs={4}>
                <TextField
                  id="studentName"
                  label="Student Name"
                  variant="outlined"
                  fullWidth
                  value={formData.studentName}
                  onChange={handleInputChange}
                  size="small"
                />
              </Grid>
            )}
             {decode?.clientId !== '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361' && (
              <Grid item xs={4}>
                <TextField
                  id="fatherName"
                  label="Father Name"
                  variant="outlined"
                  fullWidth
                  value={formData.fatherName}
                  disabled={!editableStatuses.includes(currentStatus)}
                  onChange={handleInputChange}
                  size="small"
                />
              </Grid>
            )} 
          </Grid>

          <Grid container spacing={2} sx={{ mt: 2 }}>
            <Grid item xs={4}>
              <TextField
                id="salary"
                label="Salary"
                variant="outlined"
                fullWidth
                value={formData.salary}
                disabled
                size="small"
              />
            </Grid>
            <Grid item xs={4}
                  sx={{
                    pointerEvents:
                      currentStatus === "In Sanction"
                        ? "auto"
                        : "inherit"
                  }}>
              <TextField
                id="aadhaarId"
                label="Aadhaar Number"
                variant="outlined"
                fullWidth
                value={formData.aadhaarId}
                onChange={(e) => handleInputChange(e.target.value, "aadhaarId")}
                    disabled={!isAadhaarEditable}
                size="small"
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                id="panId"
                label="Pan Number"
                variant="outlined"
                fullWidth
                value={formData.panId}
                disabled
                size="small"
              />
            </Grid>
          </Grid>

          {isDoctorInstitute && !doctorDetailsOpen && (
            <Box sx={{ mt: 3 }}>
              <Button
                variant="outlined"
                onClick={handleAddDoctorDetails}
                sx={{ borderRadius: '20px' }}
              >
                Add doctor details
              </Button>
            </Box>
          )}

          {doctorDetailsOpen && (
            <Box sx={{ mt: 3 }}>
              <Paper elevation={0} sx={{ bgcolor: '#f5f5f5', p: 2, borderRadius: 2 }}>
                <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
                  DOCTOR DETAILS
                </Typography>
                <Grid container spacing={2} sx={{ mt: 0.5 }}>
                  <Grid item xs={6}>
                    <TextField
                      id="registrationNumber"
                      label="Registration Number"
                      variant="outlined"
                      fullWidth
                      value={doctorFormData.registrationNumber}
                      onChange={handleDoctorInputChange}
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      id="yearOfRegistration"
                      label="Year of Registration"
                      variant="outlined"
                      fullWidth
                      value={doctorFormData.yearOfRegistration}
                      onChange={handleDoctorInputChange}
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      id="registeredCouncil"
                      label="Registered Council"
                      variant="outlined"
                      fullWidth
                      value={doctorFormData.registeredCouncil}
                      onChange={handleDoctorInputChange}
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      id="qualification"
                      label="Qualification"
                      variant="outlined"
                      fullWidth
                      value={doctorFormData.qualification}
                      onChange={handleDoctorInputChange}
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <FormControl fullWidth size="small">
                      <InputLabel id="doctor-file-type-label">File Type</InputLabel>
                      <Select
                        labelId="doctor-file-type-label"
                        id="certificateType1"
                        value={doctorFormData.certificateType1}
                        label="File Type"
                        onChange={(e) => setDoctorFormData((prev) => ({ ...prev, certificateType1: e.target.value }))}
                      >
                        <MenuItem value="">
                          <em>Select File Type</em>
                        </MenuItem>
                        <MenuItem value="MCIREGPROOF">MCIREGPROOF</MenuItem>
                        <MenuItem value="DEGREECERTIFICATE">DEGREECERTIFICATE</MenuItem>
                        <MenuItem value="FMGEXAMCERTIFICATE">FMGEXAMCERTIFICATE</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={6}>
                    <Button
                      variant="outlined"
                      component="label"
                      fullWidth
                      disabled={doctorUploading}
                      sx={{ height: '40px' }}
                    >
                      {doctorUploading ? 'Uploading...' : certificateUrl1 ? 'Replace File' : 'Upload File'}
                      <input type="file" hidden onChange={handleDoctorFileChange} />
                    </Button>
                    {certificateUrl1 && !doctorUploading && (
                      <Typography
                        variant="caption"
                        onClick={handleViewCertificate}
                        sx={{ display: 'block', mt: 0.5, color: 'primary.main', cursor: 'pointer', textDecoration: 'underline' }}
                      >
                        View uploaded file
                      </Typography>
                    )}
                  </Grid>
                </Grid>

                {doctorError && (
                  <Typography variant="caption" color="error" sx={{ display: 'block', mt: 1.5 }}>
                    {doctorError}
                  </Typography>
                )}

                <Box sx={{ mt: 1.5 }}>
                  <Button size="small" color="error" onClick={handleRemoveDoctorDetails}>
                    Remove doctor details
                  </Button>
                </Box>
              </Paper>
            </Box>
          )}
        </DialogContent>

        <DialogActions sx={{ bgcolor: '#f5f5f5', py: 1.5, justifyContent: 'center' }}>
          <Button 
            variant="contained" 
            onClick={handleSave}
            sx={{ 
              bgcolor: '#D32028', 
              '&:hover': { bgcolor: '#BD1C23' },
              borderRadius: '20px',
              px: 4
            }}
          >
            Save
          </Button>
        </DialogActions>
           </> }
        {tabValue === 1 && <CoapplicantEditForm coApplicantUserData={coApplicantUserData}/>}
      </DialogContent>
      </Dialog>
    </div>
  );
}